import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { Urls } from "../../constants/event-log/event-log.constants";

@autoinject()
export class EventLogsClientService {

    constructor(private requestClient: RequestClientService) {
    }

    changeStatus(ids: number[], nextStatusReasonId: number, nextStatusReasonLogNotes: string): Promise<boolean> {
        return this.requestClient.post<boolean>(Urls.ChangeStatus, {}, { nextStatusReasonId, ids, nextStatusReasonLogNotes });
    }
}